import { useQuery } from 'react-query'
import { callAxios, CustomAxiosError } from 'utils/api'
import { config } from 'config'
import { getParamsForAll, getQueryParamsForAll } from 'utils/hooks'
import { AuthContainer } from 'containers'

const { SECURE_BASE_URL } = config!

type StoreResponse = { location_id: string; location_long_name: string }[]

const getStore = async (vendorNumber: string, region: string[], storeFormat: string[]): Promise<StoreResponse> => {
  let queryParams = `vendornumber=${vendorNumber}`
  queryParams = getQueryParamsForAll(queryParams, 'region_name', region)
  queryParams = getQueryParamsForAll(queryParams, 'storeformat_name', storeFormat)

  const { response: storeResponse } = await callAxios<{
    response: { data: StoreResponse }
  }>({
    url: `${SECURE_BASE_URL}/location/store?${queryParams}`,
    method: 'GET',
  })

  const sortedResponseData = [...(storeResponse?.data ?? [])].sort(
    (a, b) => parseInt(a.location_id) - parseInt(b.location_id)
  )

  return sortedResponseData
}

export const useGetStore = (region: string[], storeFormat: string[]) => {
  const { selectedSupplier } = AuthContainer.useContainer()
  const vendorNumber = selectedSupplier?.oracleId ?? ''

  const isEnabled = !!vendorNumber && !!region.length && !!storeFormat.length

  const {
    status: storeStatus,
    isFetching: storeLoading,
    data: storeData,
    error: storeError,
  } = useQuery<StoreResponse, CustomAxiosError>(
    ['store/get', vendorNumber, getParamsForAll(region, 'only'), getParamsForAll(storeFormat, 'only')],
    () => getStore(vendorNumber, region, storeFormat),
    {
      enabled: isEnabled,
    }
  )

  return { storeStatus, storeLoading, storeData, storeError }
}
